export default __webpack_public_path__ + "static/media/O-001.ae9d90eb.png";